<cb-dialog dialogHeading="Close {{ taskTypeLabel }}">
    <form class="flex-col flex" #taskForm="ngForm">
        <label>Outcome</label>
        <mat-radio-group
            class="cb-margin-top flex-col"
            name="closetask-outcome-followup"
            [(ngModel)]="data.task.outcomeId"
        >
            @for (option of outcomes | async; track option) {
                <mat-radio-button [value]="option.id">{{ option.name }}</mat-radio-button>
            }
        </mat-radio-group>
        <mat-form-field class="cb-margin-top flex">
            <mat-label>Outcome Notes</mat-label>
            <textarea
                matInput
                name="close-task-dialog-outcome-notes"
                type="text"
                [maxlength]="1000"
                required
                [(ngModel)]="data.task.outcomeNotes"
            ></textarea>
        </mat-form-field>
        @if (data.allowFollowUp && !data.task.isCallback) {
            <cb-checkbox
                [(ngModel)]="scheduleFollowUp"
                name="closetask-schedule-followup"
                label="Schedule follow-up?"
            ></cb-checkbox>
        }
        @if (scheduleFollowUp || data.task.isCallback) {
            <div class="flex-col">
                @if (data.task.isCallback) {
                    <span class="mat-body-strong">Next {{ taskTypeLabel }}</span>
                }
                <cb-datepicker
                    name="closeTaskDialogFollowupDate"
                    [(ngModel)]="followUpTask.dueDate"
                    [required]="true"
                    label="Choose a date"
                ></cb-datepicker>
                <cb-input
                    type="text"
                    name="task-dialog-subject"
                    label="Subject"
                    [required]="true"
                    [(ngModel)]="followUpTask.subject"
                ></cb-input>
                @if (data.task.isMeeting) {
                    <cb-input
                        type="text"
                        name="task-dialog-location"
                        label="Location"
                        [required]="true"
                        [(ngModel)]="followUpTask.location"
                    ></cb-input>
                }
                <mat-form-field class="flex">
                    <mat-label>Follow-up Comments</mat-label>
                    <textarea
                        matInput
                        name="close-task-dialog-outcome-notes"
                        type="text"
                        [maxlength]="1000"
                        required
                        [(ngModel)]="followUpTask.comments"
                    ></textarea>
                </mat-form-field>
            </div>
        }
    </form>
    <div actions>
        <button
            mat-raised-button
            color="primary"
            [disabled]="!taskForm.dirty || !taskForm.valid"
            (click)="save()"
        >
            Close Task
        </button>
        <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
</cb-dialog>
